<template>
  <div class="AtlasIndicatorSummary">
    <h3 class="AtlasIndicatorSummary-stateTitle" v-if="geoType && geoName">
      {{ geoType }}: <strong>{{ geoName }}</strong>
    </h3>

    <div
      v-if="indicatorConfig.summaryHeaderImage"
      class="AtlasIndicatorSummary-image"
      :style="{
        backgroundImage: `url('${indicatorConfig.summaryHeaderImage}')`,
      }"
    ></div>

    <h4 v-if="title" class="AtlasIndicatorSummary-title">
      {{ title }}
    </h4>

    <div
      v-if="copy"
      class="AtlasIndicatorSummary-copy"
      v-html="sanitizedCopy"
    ></div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import sanitize from 'sanitize-html';

export default defineComponent({
  name: 'atlas-indicator-summary',

  emits: [],

  components: {},

  props: {
    indicatorConfig: {
      type: Number,
      required: true,
    },

    geoType: {
      type: String,
      required: false,
    },
    geoName: {
      type: String,
      required: false,
    },
  },

  computed: {
    title() {
      return (
        this.indicatorConfig.summaryHeaderTitle &&
        this.indicatorConfig.summaryHeaderTitle.replace(
          '$GEO_NAME',
          this.geoName || '',
        )
      );
    },

    copy() {
      const defaultValue = this.indicatorConfig.summaryHeaderCopy;
      return this.getGeoTypeProp('copy', defaultValue);
    },
    sanitizedCopy() {
      return this.copy ? sanitize(this.copy) : '';
    },
  },

  methods: {
    getGeoTypeProp(name, defaultValue) {
      const geoTypeInfo = (this.indicatorConfig.summaryHeader || []).find(
        (item) => (item.geo_group || '').toLowerCase() === this.typeKey,
      );

      return (geoTypeInfo || {})[name] || defaultValue;
    },
  },
});
</script>

<style lang="scss">
.AtlasIndicatorSummary {
  padding: 0 0 30px;
  background-color: #f1f2f3;
  min-width: 100%;

  &-stateTitle {
    padding-top: 15px;
    margin: 0 0 15px;
    font-size: 30px;
    font-weight: normal;
    letter-spacing: 0;
    line-height: 36px;
  }

  &-image {
    display: block;
    height: 250px;
    margin: 0 0 30px;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
  }

  &-title {
    margin: 0 0 20px;
    font-size: 30px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 36px;
  }
}
</style>
